import { saveAs } from 'file-saver';
import PropTypes from "prop-types";
import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from "shards-react";
import QuestionItem from '../components/administration/QuestionItem';
import PageTitle from "../components/common/PageTitle";
import { ReactComponent as AddQuestionIcon } from "../images/add_question.svg";
import { ReactComponent as DivisorBarIcon } from "../images/edited_divisor.svg";
import colors from "../utils/colors";

import QuestionsTemplate from '../assets/Murmuratto_Template_Questions_Test.csv';
import QuestionsService from "../services/questionsService";

import ImportDataModal from '../components/administration/ImportDataModal';
import SettingsActionButtons from '../components/common/SettingsActionButtons';
import IdeaQuestionsNew from '../components/ecommerce/IdeaQuestionsNew';


function AdministrationQuestions(smallStats) {
  const [title, setTitle] = useState('')
  const [showUser, setShowUser] = useState(false)
  const [shouldUpdateUsers, setShouldUpdateUsers] = useState(false)
  const [question, setQuestion] = useState('');
  const [questions, setQuestions] = useState([]);
  const [openModal, setOpenModal] = useState('');
  const [dataCsv, setDataCsv] = useState([]);

  const setInitialTitle = async (user) => {
    
    setTitle('Questions')

  }

  useEffect(() => {
    const fetchData = async () => {
      await getQuestions();
      setInitialTitle();
    };
    fetchData();
  }, []);

  const getQuestions = async() => {
    const questions = await QuestionsService.getQuestions();
    setQuestion(questions)
    setQuestions(questions)
  }

  const  exportData = async () => {
    try {
      const csvData = await QuestionsService.downloadDataQuestions();

      if (!csvData || csvData.length === 0) {
        return;
      }

      const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
      const currentDate = new Date().toISOString().slice(0, 10);
      const fileName = `questions_${currentDate}.csv`;

      saveAs(blob, fileName);

    } catch (error) {
      console.error('Error exporting users:', error);
    }
  }


  const updateQuestions = async () => {
    setShouldUpdateUsers(!shouldUpdateUsers)
    setShowUser(false)
    setQuestion('')
    await getQuestions();
  }

  const createUser = () => {
    setQuestion('')
    setShowUser(true)
  }

  const editItem = (item) => {
    // alert('edit me')
     
    setQuestion(item)
    setShowUser(true)
  }

  const uploadData = () => {
    setOpenModal(true)
  }

  const onFinish = () => {
    alert("Your data was imported succesfully!")
    setOpenModal(false)
    setShouldUpdateUsers(!shouldUpdateUsers)
    setShowUser(false)
    setQuestion('')
    // getCategories()
  }

  return (
    <Container fluid className="main-content-container px-4" style={{backgroundColor: 'white'}}>
      <Row>
        <Col md="12" lg="12" className="pt-4 mx-auto">
          <Row className="align-items-center d-flex">
            <Col md="8" lg="8" className="d-flex align-items-center">
              <Row noGutters className="page-header">
                    <PageTitle title={title} subtitle={'Administration'} className="text-sm-left mb-3" />
              </Row>
            </Col>
            <Col xs="12" md="4" lg="4" className="d-flex justify-content-end align-items-center">
              <SettingsActionButtons uploadData={() => uploadData()} templateFile={QuestionsTemplate} exportData={() => exportData()} dataCsv={dataCsv}></SettingsActionButtons>
            </Col>
        </Row>
        <Row>
          <Col>
            <DivisorBarIcon></DivisorBarIcon>
          </Col>
        </Row>
      </Col>
      
    </Row>

    
    
    <Row className="mt-4">
      <Col lg="12" className="m-auto">
        <AddQuestionIcon className="functionalButton mr-4 d-block mb-4" style={{minWidth: 180, maxWidth:180}} onClick={() => createUser()}></AddQuestionIcon>
      </Col>
    </Row>

    <Row className="mt-2">
        <Col md="12" lg="12">
        { showUser && <QuestionItem key={Math.random()} id={Math.random()}  updateQuestions={updateQuestions} question={question}></QuestionItem>}
        </Col>
    </Row>

    <Row className="mt-2">
        <Col lg="12" className="m-auto">
            <div style={{backgroundColor: '#F6F6F6', height: 500, overflow: 'scroll', borderStyle: 'solid', borderColor: 'black', borderWidth: 2, borderRadius: 5, marginBottom: 100}}>
              {questions.length > 0 && <IdeaQuestionsNew questions={questions} shouldUpdate={shouldUpdateUsers} editItem={(question) => editItem(question)} setDataCsv={(data) => setDataCsv(data)}/>}
            </div>
        </Col>
    </Row>
        
    <ImportDataModal open={openModal} onFinish={() => onFinish()} dataType="questions"></ImportDataModal>
    
  </Container>
  )}

AdministrationQuestions.propTypes = {
  /**
   * The small stats data.
   */
  smallStats: PropTypes.array
};

AdministrationQuestions.defaultProps = {
  signedIn: true,
  smallStats: [
    {
      label: "Ideas Submitted",
      value: "18",
      percentage: "12.4%",
      increase: true,
      chartLabels: [null, null, null, null, null],
      decrease: false,
      datasets: [
        {
          label: "Today",
          fill: "start",
          borderWidth: 1.5,
          backgroundColor: colors.primary.toRGBA(0.1),
          borderColor: colors.primary.toRGBA(),
          data: [9, 3, 3, 9, 9]
        }
      ]
    },
    {
      label: "Ideas Accepted",
      value: "7",
      percentage: "7.21%",
      increase: false,
      chartLabels: [null, null, null, null, null],
      decrease: true,
      datasets: [
        {
          label: "Today",
          fill: "start",
          borderWidth: 1.5,
          backgroundColor: colors.success.toRGBA(0.1),
          borderColor: colors.success.toRGBA(),
          data: [3.9, 4, 4, 9, 4]
        }
      ]
    },
    {
      label: "Ideas in Progress",
      value: "4",
      percentage: "3.71%",
      increase: true,
      chartLabels: [null, null, null, null, null],
      decrease: false,
      datasets: [
        {
          label: "Today",
          fill: "start",
          borderWidth: 1.5,
          backgroundColor: colors.warning.toRGBA(0.1),
          borderColor: colors.warning.toRGBA(),
          data: [6, 6, 9, 3, 3]
        }
      ]
    },
  ]
};

export default AdministrationQuestions;
